"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THEME = __importStar(require("../../themes/colors"));
const getFlexStyleForColumn = (column, config) => {
    const flexValue = `0 0 ${config.width}px`;
    const style = {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue,
        overflow: 'hidden'
    };
    // TODO: Need to fix (https://tfs.veeam.dev/DefaultCollection/UIKit/_workitems/edit/254663)
    if (column.props.totalColumn && config.isHeaderCell) {
        Object.assign(style, {
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            backgroundColor: config.disabled
                ? THEME.blue.colorBackgroundNeutralLight
                : THEME.blue.colorHighlightNotification
        });
    }
    return style;
};
exports.default = getFlexStyleForColumn;
//# sourceMappingURL=getFlexStyleForColumn.js.map